import { Reducer } from 'redux';
import { GET_SUPPLIER_INFO, PUT_SUPPLIER_INFO, SupplierInfoActionTypes, SupplierInfoState } from '../types/supplierinfo.types';

const initialState: SupplierInfoState = {
  selectedSupplierInfo: null,
  supplierInfo: null,
  lastFetch: null,
  postSuccess: null
};

export const supplierInfoReducer: Reducer<SupplierInfoState> = (
  state: SupplierInfoState = initialState, action
) => {
  const timeOfAction = new Date().getTime();

  switch ((action as SupplierInfoActionTypes).type) {
    case GET_SUPPLIER_INFO:
      return {
        ...state,
        supplierInfo: action.payload.supplierInfo,
        lastFetch: timeOfAction,
        postSuccess: null
      };
    case PUT_SUPPLIER_INFO:
      return {
        ...state,
        selectedSupplierInfo: action.payload.selectedSupplierInfo,
        postSuccess: true,
        lastFetch: timeOfAction
      };
    default:

      return state;
  }
};
